import { HttpErrorResponse } from '@angular/common/http';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { usersPerPageInitial } from '../constants';
import { User } from '../entities';

import * as UsersActions from './users.actions';
import { UsersPageParams } from './users.model';

export const featureKey = 'users';

export interface UsersState {
    loading: boolean;
    loaded: boolean;
    pageParams: UsersPageParams;
    totalPages?: number;
    totalElements?: number;
    number: number;
    numberOfElements?: number;
    listError?: HttpErrorResponse;
    idsInProgress: number[];
}

export interface UsersEntityState extends EntityState<User>, UsersState {}

const initialPageParams: UsersPageParams = {
    page: 0,
    size: usersPerPageInitial
};
const initialState = {
    loading: true,
    loaded: false,
    pageParams: { ...initialPageParams },
    number: 0,
    idsInProgress: []
} as UsersState;

export const usersAdapter: EntityAdapter<User> = createEntityAdapter<User>();

const initialUsersState = usersAdapter.getInitialState(initialState);

export const reducer = createReducer(
    initialUsersState,
    on(UsersActions.loadUsers, (state) => ({ ...state, loading: true, listError: undefined })),
    on(UsersActions.loadUsersSuccess, (state, response) =>
        usersAdapter.setAll(response.content, {
            ...state,
            totalPages: response.totalPages,
            totalElements: response.totalElements,
            number: response.number,
            numberOfElements: response.numberOfElements,
            loading: false,
            loaded: true
        })
    ),
    on(UsersActions.loadUsersFailure, (state, { error }) => ({ ...state, listError: error, loading: false })),
    on(UsersActions.resetUsers, (state) =>
        usersAdapter.removeAll({
            ...state,
            ...initialState
        })
    ),
    on(UsersActions.setPageParams, (state, { pageParams }) => ({ ...state, pageParams })),
    on(UsersActions.deleteUsers, (state, { ids }) => ({
        ...state,
        idsInProgress: [...state.idsInProgress, ...ids],
        deleteUsersError: undefined
    })),
    on(UsersActions.deleteUsersSuccess, (state, { ids }) =>
        usersAdapter.removeMany(ids, {
            ...state,
            idsInProgress: state.idsInProgress.filter((id) => !ids.includes(id))
        })
    ),
    on(UsersActions.deleteUsersFailure, (state, { ids }) => ({
        ...state,
        idsInProgress: state.idsInProgress.filter((id) => !ids.includes(id))
    })),
    on(UsersActions.changeUserBlocked, (state, { id }) => ({
        ...state,
        idsInProgress: [...state.idsInProgress, id]
    })),
    on(UsersActions.changeUserBlockedSuccess, (state, update) =>
        usersAdapter.updateOne(update, {
            ...state,
            idsInProgress: state.idsInProgress.filter((progressId) => progressId !== update.id)
        })
    ),
    on(UsersActions.changeUserBlockedFailure, (state, { id }) => ({
        ...state,
        idsInProgress: state.idsInProgress.filter((progressId) => progressId !== id)
    }))
);
